export default "__VITE_ASSET__BnqJ_uB9__"